// @flow

import { connect } from 'react-redux';
import { WorkInfo } from '../../components/works';

const mapState = () => ({
  className: 'search-works',
  title: 'Search Results',
  backLinkTo: '/searchworks',
  backLinkText: 'Search results',
});

export default connect(
  mapState,
)(WorkInfo);
